import axios, { AxiosError, AxiosInstance, InternalAxiosRequestConfig } from "axios";
import { GOVAxiosRequestConfig, GOVToken } from "./GOV.type";
import GOVConfig from "./GOV.config";

export class GOVRequester {
    private static async authInterceptor(
        config: InternalAxiosRequestConfig,
    ): Promise<InternalAxiosRequestConfig> {
        const tokenString = window.sessionStorage.getItem("GOV_TOKEN");
        const newConfig = config;
        
        if (tokenString) {
            const token: GOVToken = JSON.parse(tokenString);
            newConfig.headers.Authorization = `Bearer ${token.access_token}`;
        }
        return newConfig;
    }

    private static async errorInterceptor(error: AxiosError) {
        const originalRequest = error.config as GOVAxiosRequestConfig;
        if (error.response?.status === 401 && !originalRequest.retry && originalRequest?.headers) {
            originalRequest.retry = true;
            try {
                const tokenString = await GOVRequester.auth();
                const token: GOVToken = JSON.parse(tokenString);
                originalRequest.headers.Authorization = `Bearer ${token.access_token}`;
                return await axios(error.config as InternalAxiosRequestConfig);
            } catch (newError) {
                return Promise.reject(error);
            }
        }
        return Promise.reject(error);
    }

    static create(): AxiosInstance {
        const instance: AxiosInstance = axios.create({
            baseURL: GOVConfig.url,
        });

        instance.interceptors.request.use(GOVRequester.authInterceptor, (error) =>
            Promise.reject(error),
        );
        instance.interceptors.response.use((res) => res, GOVRequester.errorInterceptor);
        return instance;
    }

    static async auth() {
        const params = new URLSearchParams();
        params.append("grant_type", "client_credentials");
        params.append("client_secret", GOVConfig.clientSecret || "");
        params.append("client_id", GOVConfig.clientId || "");
        params.append("scope", "api-cnpj-v1");
        const { data: token } = await axios.post<GOVToken>(`${GOVConfig.url}/token`, params);
        console.log("'params '");
        window.sessionStorage.setItem("GOV_TOKEN", JSON.stringify(token));
        return JSON.stringify(token);
    }
}

export default GOVRequester;
